function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_7281",
  "data-name": "Path 7281",
  d: "M1981.484,544.453c-283.953,0-514,230.16-514,514H1594.3c23.609,0,44.094-17.329,46.883-40.787a341.425,341.425,0,0,1,75.848-177.114q10.465-12.693,22.125-24.341a343.253,343.253,0,0,1,344.184-84.937c126.879,39.462,222.172,150.711,238.316,286.229,2.8,23.506,23.191,40.949,46.875,40.949h126.957c0-283.84-230.16-514-514-514",
  transform: "translate(-544.453 2495.484) rotate(-90)",
  fill: "current"
});

function SvgRightCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 514,
    height: 1028,
    viewBox: "0 0 514 1028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCircle);
export default __webpack_public_path__ + "static/media/rightCircle.f402c03a.svg";
export { ForwardRef as ReactComponent };